import {
  createRouter,
  createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordRaw
} from 'vue-router';
import accountRouters from './account';
import welcomeRouters from './welcome';
import errorsRouters from './errors';
import { useAccountStore } from "@/store/modules/account.ts";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    redirect: '/login'
  },
  ...accountRouters,
  ...welcomeRouters,
  ...errorsRouters,
  {
    // 用户服务协议
    path: '/rule',
    name: 'rule',
    component: () => import('../views/agreement/rule.vue')
  },
  {
    // 404页面
    path: '/:pathMatch(.*)*',
    component: () => import('../views/errors/404.vue')
  }
]

const router = createRouter({
  history: createWebHistory(''),
  routes
})

// 路由拦截
router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const userStore = useAccountStore()
  if (to.path === '/login') {
    if (!userStore.getNonce() && to.query && to.query.nonce) {
      userStore.setAccount(to.query.nonce as string || '', to.query.target as string || userStore.getTargetUrl())
      next() // 继续导航到登录页面
    } else if (userStore.getNonce()) {
      if (from.path === '/' || from.path === '') {
        location.href = userStore.getTargetUrl() as string; // 直接跳转目标页面，不再去/welcome页面
        next(false);
      } else {
        next(false)
      }
    } else {
      // 没有nonce，正常跳转到登录页面
      next()
      console.log('没有nonce，正常跳转到登录页面', to.path);
    }
  } else {
    // 非登录页面，正常导航
    next()
  }
})

export default router
